export default __webpack_public_path__ + "static/media/logosMobile4.cf7c940a.png";